import script from "./S2gTable.vue?vue&type=script&setup=true&lang=js"
export * from "./S2gTable.vue?vue&type=script&setup=true&lang=js"

import "./S2gTable.vue?vue&type=style&index=0&id=148d170c&lang=scss"

const __exports__ = script;

export default __exports__